// "Copiar ubicación" (puro, con tests).
//
// En la plataforma anterior era de las acciones más usadas: el monitorista
// copia dónde está la unidad y lo pega en WhatsApp al cliente o al operador.
// Un link de Google Maps abre directo en el teléfono de quien lo recibe; las
// coordenadas sueltas obligan a pegarlas a mano en un mapa.

// 6 decimales ≈ 11 cm: de sobra para ubicar una unidad. Más decimales sólo
// alargan el mensaje.
const fmt = (n: number) => n.toFixed(6);

// Number(null) y Number("") dan 0: sin este filtro una latitud vacía pasaría
// como el ecuador.
const blank = (v: unknown) => v == null || (typeof v === "string" && v.trim() === "");

export const locationLink = (lat: unknown, lng: unknown): string | null => {
  if (blank(lat) || blank(lng)) return null;
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return null;
  if (Math.abs(la) > 90 || Math.abs(ln) > 180) return null;
  // 0,0 es el "sin GPS" de varios equipos (cae en el golfo de Guinea): copiarlo
  // mandaría al cliente a medio océano.
  if (la === 0 && ln === 0) return null;
  return `https://www.google.com/maps?q=${fmt(la)},${fmt(ln)}`;
};

// navigator.clipboard sólo existe en contextos seguros (https o localhost).
// Fuera de eso, o si el navegador niega el permiso, se usa el textarea +
// execCommand, que sigue funcionando en todos los navegadores de escritorio.
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* cae al método viejo */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
